import React from 'react';
import { CustomerStatusWrapper } from './CustomerStatusStyled';
import { Box } from "@mui/material";
import customer from '../../../images/customerIcon.svg';
import check from '../../../images/checkIcon.svg';
import date from '../../../images/dateIcon.svg';
import Opportunity from '../../../images/opportunity.svg';
import New from '../../../images/new.svg';
import account from '../../../images/allstatusinputIcon.svg';
import { CustomerStatusConstants } from '../../ViewRequest/Content';
import moment from 'moment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { QuoteStatus } from '../../QuoteRequest/Content';



const CustomerStatus = ({ quoteDetails, opportunityDetails, handleSelectChange, statusList,status, isPricingTeam,isSamLeadership,isInitialUser,headCount }) => {
    const statusColors = {
        'Quote Pending SAM Leadership': '#8A9123',
        'Quote Pending Pricing Team': '#8A9123',
        'Quote Closed': '#C81E1E',
        'Quote Approved': '#00AF97',
        'Quote Submitted': '#239155',
        'Contracted': '#91238D',
        'Save as draft': '#229353',
        'Quote Pending \nInitial Requestor': '#E27900',
        'Closed without approval': '#2eb71e'
        // Add more status values and colors as needed
    };
    return (
        <CustomerStatusWrapper className="customerStatus">
            <Box className="d-flex">
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={customer} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.CUSTOMER}</h4>
                        <p className={`para0`}>{opportunityDetails?.accountName}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={check} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.STATUS}</h4>

                        {isPricingTeam && quoteDetails?.quoteStatusId === QuoteStatus.QUOTEAPPROVED ?
                            <Select size='small' className="customDropdown" value={quoteDetails?.quoteStatusId} name="statusId"
                            style={{ color: statusColors[quoteDetails?.statusName] ?? 'black' }}
                                onChange={handleSelectChange}
                            >
                                <MenuItem divider key={quoteDetails?.quoteStatusId} value={quoteDetails?.quoteStatusId}>
                                    {quoteDetails?.statusName}
                                </MenuItem>
                                {statusList.map((option) => (
                                    <MenuItem divider key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </Select> :
                            isPricingTeam && quoteDetails?.quoteStatusId === QuoteStatus.CONTRACTED || quoteDetails?.quoteStatusId === QuoteStatus.CONTRACTEDRESERVATIONSCONTRACTEDTERMUTILIZATION ||
                                quoteDetails?.quoteStatusId === QuoteStatus.CONTRACTEDRESERVATIONSMINBILLINGNOTGUARANTEED || quoteDetails?.quoteStatusId === QuoteStatus.CONTRACTEDRESERVATIONSMARGINCONCERNS ?
                                <Select size='small' className="customDropdown"  value={quoteDetails?.quoteStatusId} name="statusId"
                                   onChange={handleSelectChange} style={{ color: statusColors[quoteDetails?.statusName] ?? 'black' }}
                                >
                                    {statusList.map((option) => (
                                        <MenuItem divider key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select> :
                                ((isPricingTeam && quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGTEAM) ||
                                 (isSamLeadership && quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP) ||
                                (isInitialUser && quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR))  ?
                                <Select size='small' className="customDropdown" value={quoteDetails?.quoteStatusId} name="statusId"
                                style={{ color: statusColors[quoteDetails?.statusName] ?? 'black' }}
                                    onChange={handleSelectChange}
                                >
                                    <MenuItem divider key={quoteDetails?.quoteStatusId} value={quoteDetails?.quoteStatusId}>
                                        {quoteDetails?.statusName}
                                    </MenuItem>
                                    <MenuItem divider key={status.id} value={status.id}>
                                        {status.name}
                                    </MenuItem>
                                </Select> :
                                <p className={`para0`} style={{ color: statusColors[quoteDetails?.statusName] ?? 'black' }}>{quoteDetails?.statusName}</p>}
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={date} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.DATE}</h4>
                        <p className={`para0`}>{moment(quoteDetails?.createdDate).format('MM-DD-YYYY')}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={check} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.LOCATION}</h4>
                        <p className={`para0`}>{opportunityDetails?.billingCountry}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={Opportunity} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.OPPORTUNITYNAME}</h4>
                        <p className={`para0`}>{opportunityDetails?.oppurtunity}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={Opportunity} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.OPPORTUNITYTYPE}</h4>
                        {/*<p className={`para0`}>*/}{/*opportunityDetails?.oppurtunityType*/}{/*</p>*/}
                        <p className={`para0`}>{quoteDetails?.oppurtunityType}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={New} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.AM}</h4>
                        <p className={`para0`}>{opportunityDetails?.accountOwner}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.PARTNERRESELLER}</h4>
                        <p className={`para0`}>{opportunityDetails?.memberOf}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.SALESLEAD}</h4>
                        <p className={`para0`}>{opportunityDetails?.opportunitySaleLead ? opportunityDetails?.opportunitySaleLead : "--"}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.AMLEAD}</h4>
                        <p className={`para0`}>{opportunityDetails?.opportunityAmLead ? opportunityDetails?.opportunityAmLead : "--"}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.ADDITIONALTEAMMEMBER}</h4>
                        <p className={`para0`}>{opportunityDetails?.opportunityAdditionTeamMember ? opportunityDetails?.opportunityAdditionTeamMember : "--"}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.ACSUBTYPE}</h4>
                        <p className={`para0`}>{opportunityDetails?.accountSubType}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={account} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.TOTALHEADCOUNT}</h4>
                        <p className={`para0`}>{headCount?.toLocaleString()}</p>
                    </div>
                </div>
                <div className="customerDetails">
                    <div className="imgIcon">
                        <img src={New} alt="img" />
                    </div>
                    <div className="contentUser">
                        <h4 className="h4padding">{CustomerStatusConstants.UCMSID}</h4>
                        <p className={`para0`}>{opportunityDetails?.ucmsId}</p>
                    </div>
                </div>
            </Box>
        </CustomerStatusWrapper>
    );
};

export default CustomerStatus;
